<template>
  <div>
    <h1 class="mb-8 font-bold text-3xl">
      <inertia-link class="text-indigo-400 hover:text-indigo-600" :href="route('despachos')">Despacho:</inertia-link>
      <span class="text-indigo-400 font-medium">/</span>
      {{ form.numero_comprobante }}
    </h1>
    <trashed-message v-if="despacho.deleted_at" class="mb-6" @restore="restore">
     Despacho Removed!
    </trashed-message>
    <div class="bg-white rounded-md shadow overflow-hidden max-w-3xl">
      <form @submit.prevent="update">
         <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
           <label class="pr-6 pb-8">Fecha:</label>
        <Datepicker  v-model="form.fecha" :error="form.errors.fecha" class="pr-6 pb-8 w-full lg:w-6/6" format="YYYY-MM-DD H:i:s" required/>
        <select-input v-model="form.maquinaria_id" :error="form.errors.maquinaria_id" class="pr-6 pb-8 w-full lg:w-1/3" label="Maquinaria/Vehiculo" required>
            <option v-for="maquinaria in maquinarias" :key="maquinaria.id" :value="maquinaria.id">{{ maquinaria.codigo }} - {{ maquinaria.clase}} - {{maquinaria.placas}}</option>
        </select-input>

        <select-input v-model="form.proyecto" :error="form.errors.proyecto" class="pr-6 pb-8 w-full lg:w-1/3" label="Destino de Proyecto" required>
            <option v-for="proyecto in proyectos" :key="proyecto.id">{{ proyecto.nombre}}</option>
        </select-input>
        <select-input v-model="form.operador" :error="form.errors.operador" class="pr-6 pb-8 w-full lg:w-1/3" label="Operador" required>
            <option v-for="conductor in conductores" :key="conductor.id">{{ conductor.nombres }} {{ conductor.apellidos }}</option>
        </select-input>
         <select-input v-model="form.gasolinera" :error="form.errors.gasolinera" class="pr-6 pb-8 w-full lg:w-1/5" label="Gasolinera" required>
          <option v-for="gasolinera in gasolineras" :key="gasolinera.id" :value="gasolinera.nombre">{{ gasolinera.nombre }}</option>
        </select-input>
          <text-input v-model="form.numero_comprobante" :error="form.errors.numero_comprobante" class="pr-6 pb-8 w-full lg:w-1/5" label="Nº Comprobante" required/>
         <text-input v-if="gasolineraSeleccionada && gasolineraSeleccionada.documento_editable" v-model="form.numero_documento" :error="form.errors.numero_documento"  class="pr-6 pb-8 w-full lg:w-1/5" label="Nº Documento" required/>
           <text-input v-model="form.cantidad_tanqueada" :error="form.errors.cantidad_tanqueada" class="pr-6 pb-8 w-full lg:w-1/5" label="Total Galones" required/>
          <text-input v-model="form.odometro_actual" :error="form.errors.odometro_actual" class="pr-6 pb-8 w-full lg:w-1/5" label="Odometro" required/>
                    <text-input v-model="form.observacion" :error="form.errors.observacion" class="pr-6 pb-8 w-full lg:w-1/1" label="Observación" />
          <br><br><br><br><br>
          </div>
        <div class="px-8 py-4 bg-gray-50 border-t border-gray-100 flex items-center">
          <button v-if="!despacho.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button" @click="destroy">Borrar Despacho</button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">Guardar Despacho</loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Datepicker from 'vuejs-datetimepicker'

export default {
  metaInfo() {
    return {
      title: `${this.form.numero_comprobante}`,
    }
  },
  components: {
    LoadingButton,
    SelectInput,
    TextInput,
    TrashedMessage,
    Datepicker
  },
  layout: Layout,
  props: {
    despacho: Object,
    maquinarias: Array,
    proyectos: Array,
    conductores: Array,
    gasolineras: Array,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
       maquinaria_id: this.despacho.maquinaria_id,
        fecha: this.despacho.fecha,
        proyecto: this.despacho.proyecto,
        operador: this.despacho.operador,
        gasolinera: this.despacho.gasolinera,
        numero_comprobante: this.despacho.numero_comprobante,
        numero_documento: this.despacho.numero_documento,
        cantidad_tanqueada: this.despacho.cantidad_tanqueada,
        odometro_actual: this.despacho.odometro_actual,
        observacion: this.despacho.observacion,

      }),
    }
  },
  computed: {
    gasolineraSeleccionada() {
      return this.gasolineras.find(g => g.nombre === this.form.gasolinera)
    },
  },
  watch: {
    // Solo al cambiar de gasolinera; al abrir se conserva el Nº guardado
    'form.gasolinera'() {
      this.form.numero_documento = this.gasolineraSeleccionada ? this.gasolineraSeleccionada.numero_documento || '' : ''
    },
  },
  methods: {
    update() {
      this.form.put(this.route('despachos.update', this.despacho.id))
    },
    destroy() {
      if (confirm('Estas Seguro de Eliminar?')) {
        this.$inertia.delete(this.route('despachose.destroy', this.despacho.id))
      }
    },
    restore() {
      if (confirm('Piensalo Bien!?')) {
        this.$inertia.put(this.route('despachos.restore', this.despacho.id))
      }
    },
  },
}
</script>
